import toolkit from '@/app/mixins/toolkit/item';
import pension from '@/app/mixins/toolkit/pension/pension';
import { dollar } from '@/app/filters/filters';

export default {
  name: 'trustee-letter',
  mixins: [toolkit, pension],
  computed: {
    fund() {
      return this.$store.getters['fund/getFund'];
    },
    fundName() {
      return this.fund.details.name;
    },
    trusteeType() {
      return this.fund.trustee.type;
    },
    trisWording() {
      if (this.isTris) {
        return 'a transition to retirement pension';
      }
      return 'an account-based pension';
    },
    pensionAmountDeterminedText() {
      const reasons = {
        "The whole balance of the pensioner's accumulation account":
          'The pension will commence with your entire accumulation account at that time.',
        "The balance of the pensioner's accumulation account less a fixed amount": `The pension will commence with your entire accumulation account less a fixed amount of ${dollar(
          this.pensionFixedAmount,
        )}.`,
        'As much as possible without going over the transfer balance cap':
          'The pension will commence with as much as possible of your accumulation balance at that time without exceeding your transfer balance cap.',
        'A fixed amount': `The pension will commence with a fixed amount of ${dollar(this.pensionFixedAmount)}.`,
      };

      const ratifiedReasons = {
        "The whole balance of the pensioner's accumulation account":
          'The pension commenced with your entire accumulation balance at that time.',
        "The balance of the pensioner's accumulation account less a fixed amount": `The pension commenced with your entire accumulation account at that time less a fixed amount of ${dollar(
          this.pensionFixedAmount,
        )}.`,
        'As much as possible without going over the transfer balance cap':
          'The pension commenced with as much as possible of your accumulation balance at that time without exceeding your transfer balance cap.',
        'A fixed amount': `The pension commenced with a fixed amount of ${dollar(this.pensionFixedAmount)}.`,
      };

      if (this.getItem.requirements.ratify) {
        return ratifiedReasons[this.getItem.setup.howMuch];
      }

      return reasons[this.getItem.setup.howMuch];
    },
  },
};
